import axios from 'axios';

// 创建axios实例
const api = axios.create({
  baseURL: process.env.REACT_APP_API_URL || '',
  timeout: 10000,
  headers: {
    'Content-Type': 'application/json',
  },
});

// 请求拦截器 - 添加认证token
api.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('auth_token');
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// 响应拦截器 - 处理错误
api.interceptors.response.use(
  (response) => {
    return response.data;
  },
  (error) => {
    if (error.response) {
      // 服务器返回错误状态码
      const { status, data } = error.response;
      
      if (status === 401) {
        // 认证失败，清除本地存储并重定向到登录页
        localStorage.clear();
        window.location.href = '/login';
      } else if (status === 403) {
        // 权限不足
        console.error('权限不足:', data.error || '无权限访问此资源');
      } else if (status === 404) {
        console.error('资源不存在:', data.error || '请求的资源不存在');
      } else if (status >= 500) {
        console.error('服务器错误:', data.error || '服务器内部错误');
      }
    } else if (error.request) {
      // 请求发出但没有收到响应
      console.error('网络错误:', '请检查网络连接或服务器状态');
    } else {
      // 请求配置出错
      console.error('请求错误:', error.message);
    }
    
    return Promise.reject(error);
  }
);

// 导出API方法
export const authAPI = {
  login: (data) => api.post('/api/auth/login', data),
  logout: () => api.post('/api/auth/logout'),
  profile: () => api.get('/api/auth/profile'),
  tenants: () => api.get('/api/auth/tenants'),
  register: (data) => api.post('/api/auth/register', data),
};

export const tenantAPI = {
  getInfo: () => api.get('/api/tenants'),
  update: (data) => api.put('/api/tenants/update', data),
  getUsers: () => api.get('/api/tenants/users'),
  getUserDetail: (userId) => api.get(`/api/tenants/users/${userId}`),
  createUser: (data) => api.post('/api/tenants/users', data),
  updateUser: (userId, data) => api.put(`/api/tenants/users/${userId}`, data),
  deleteUser: (userId) => api.delete(`/api/tenants/users/${userId}`),
};

export const inspectionAPI = {
  getAll: (params) => api.get('/api/inspections', { params }),
  getDetail: (inspectionId) => api.get(`/api/inspections/${inspectionId}`),
  create: (data) => api.post('/api/inspections', data),
  update: (inspectionId, data) => api.put(`/api/inspections/${inspectionId}`, data),
  delete: (inspectionId) => api.delete(`/api/inspections/${inspectionId}`),
  getStatistics: () => api.get('/api/inspections/statistics'),
};

export const trainingAPI = {
  getAll: (params) => api.get('/api/trainings', { params }),
  getDetail: (trainingId) => api.get(`/api/trainings/${trainingId}`),
  create: (data) => api.post('/api/trainings', data),
  update: (trainingId, data) => api.put(`/api/trainings/${trainingId}`, data),
  delete: (trainingId) => api.delete(`/api/trainings/${trainingId}`),
  getStatistics: () => api.get('/api/trainings/statistics'),
};

export const certificateAPI = {
  getAll: (params) => api.get('/api/certificates', { params }),
  getDetail: (certificateId) => api.get(`/api/certificates/${certificateId}`),
  create: (data) => api.post('/api/certificates', data),
  update: (certificateId, data) => api.put(`/api/certificates/${certificateId}`, data),
  delete: (certificateId) => api.delete(`/api/certificates/${certificateId}`),
  getStatistics: () => api.get('/api/certificates/statistics'),
};

export const dashboardAPI = {
  getOverview: () => api.get('/api/dashboard/overview'),
  getInspectionChart: () => api.get('/api/dashboard/inspection-chart'),
  getTrainingChart: () => api.get('/api/dashboard/training-chart'),
  getActivities: () => api.get('/api/dashboard/activities'),
  getNotifications: () => api.get('/api/dashboard/notifications'),
  markNotificationRead: (notificationId) => api.put(`/api/dashboard/notifications/${notificationId}/read`),
  markAllNotificationsRead: () => api.put('/api/dashboard/notifications/all-read'),
};

export const logAPI = {
  getLogs: (params) => api.get('/api/logs', { params }),
  getStatistics: () => api.get('/api/logs/statistics'),
  exportLogs: (params) => api.get('/api/logs/export', { params }),
  cleanupLogs: (data) => api.post('/api/logs/cleanup', data),
};

// 组件化的拦截器包装
export const AxiosInterceptor = ({ children }) => {
  // 这里的拦截器已经在axios实例中配置，不需要额外包装
  return children;
};

export default api;